import { render, staticRenderFns } from "./DS_features_module_zero.vue?vue&type=template&id=0b1a981b&"
import script from "./DS_features_module_zero.vue?vue&type=script&lang=js&"
export * from "./DS_features_module_zero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports